'use strict';

export class CountrySelect {
	constructor($element) {
		this.$root_element = $element;
		this.$button = this.$root_element.find('.js-country_select_button');
		this.$list = this.$root_element.find('.js-country_select_list');
	}
	
	init() {
		this.$button.on({
			click: this.toggle.bind(this)
		});
		this.$button.on('keydown', yalwa.basics.keyhandler_for_space_and_enter);
		jQuery('body').on('click', this.hide.bind(this));
	}
	
	toggle() {
		yalwa.basics.toggle(this.$list)
	}
	
	show(event) {
		yalwa.basics.show(this.$list);
	}
	
	hide(event) {
		if (
			!jQuery(event.target).closest('.js-country_select').length &&
			!jQuery(event.target).hasClass('js-country_select')
		) {
			yalwa.basics.hide(this.$list);
		}
	}
}
